import { render, staticRenderFns } from "./ques11.vue?vue&type=template&id=0edc9136&scoped=true"
import script from "./ques11.vue?vue&type=script&lang=js"
export * from "./ques11.vue?vue&type=script&lang=js"
import style0 from "./ques11.vue?vue&type=style&index=0&id=0edc9136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc9136",
  null
  
)

export default component.exports